import React from "react";
import { Icon } from "./ui";
import { Headline, Paragraph } from "./ui/Typography";

const IconBulletListV2 = ({
  items = [],
  icon = "check",
  headline = null,
  highlightedIndices = [],
  className = "",
}) => {
  return (
    <div className={className}>
      {headline && (
        <Headline
          variant="splitscreen-heading"
          color="grayDark"
          animate={false}
        >
          {headline}
        </Headline>
      )}

      <ul className="space-y-3">
        {items.map((item, index) => {
          const isHighlighted = highlightedIndices.includes(index);
          return (
            <li
              key={index}
              className={`flex items-start gap-3 p-3 rounded-sm ${
                isHighlighted ? "border-2 border-dotted border-green-400" : ""
              }`}
              style={{
                backgroundColor: isHighlighted
                  ? "rgba(34, 197, 94, 0.05)"
                  : "transparent",
              }}
            >
              <Icon
                name={icon}
                size="sm"
                className="text-green-500 flex-shrink-0 mt-1"
              />
              <Paragraph
                variant="large"
                color="gray"
                noSpacing={true}
                className={isHighlighted ? "font-semibold" : ""}
                dangerouslySetInnerHTML={{ __html: item }}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default IconBulletListV2;
